import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { Column } from 'features/Yucollect/utils/types';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchAllocationFileSummary,
  fetchAllocationRecordsById,
  fetchChannelPlannerMetrics,
} from 'redux/slice/allocation/AllocationDetails.slice';
import {
  assignChannel,
  assignChannelFailure,
  assignChannelSuccess,
} from 'redux/slice/allocation/ChannelAllocation.slice';
import {
  IAssignChannelRequest,
  IAssignChannelResponse,
} from 'redux/types/Channel.types';
import { allocationEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

import { handleError } from '../utils/errorUtils';

// Saga for assigning channel
function* assignChannelSaga(action: PayloadAction<IAssignChannelRequest>) {
  try {
    const {
      channel = [],
      filters = {},
      allocationId,
      isClosed,
      isValid = false,
      selectedAllocationIDs,
      unselectedAllocationIDs,
    } = action.payload;
    const response: AxiosResponse<IAssignChannelResponse> =
      yield HTTPClient.PostRequest(
        `${allocationEndpoints.ASSIGN_CHANNEL(
          allocationId,
          isClosed,
          isValid
        )}`,
        {
          channel,
          filters,
          selectedAllocationIDs,
          unselectedAllocationIDs,
        }
      );
    yield put(assignChannelSuccess(response.data));

    // Refresh data grid, summary, and channel metrics after successful assignment
    yield put(
      fetchAllocationRecordsById({
        allocationId,
        isClosed,
        isValid,
        columns: [],
      })
    );
    yield put(
      fetchAllocationFileSummary({
        allocationId,
        isClosed,
        isValid,
        filters: filters as { columns: Column[] },
        isGlobalSearch: false,
        globalSearchValue: '',
      })
    );
    yield put(
      fetchChannelPlannerMetrics({
        allocationId,
        isClosed,
        isValid,
        columns: [],
      })
    );
  } catch (error: any) {
    yield* handleError(error, assignChannelFailure, '');
  }
}

export function* watchAssignChannelSagas() {
  yield takeLatest(assignChannel.type, assignChannelSaga);
}
